// Match MIN_PASSWORD_LENGTH and MAX_PASSWORD_LENGTH in services/orders/auth.py.
const MIN_LENGTH = 12;
const MAX_LENGTH = 128;

// Auth0's "Good" policy (dev and prod) needs 3 of these 4 character types.
// The sets match Auth0's password-sheriff rules.
const CHARACTER_TYPES = [
  /[a-z]/,
  /[A-Z]/,
  /[0-9]/,
  /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/,
];
const MIN_CHARACTER_TYPES = 3;

const TYPES_RULE =
  "3 of the following: lowercase letters, uppercase letters, numbers, special characters";

export const PASSWORD_HINT = `Your password must contain at least ${MIN_LENGTH} characters and ${TYPES_RULE}`;
export const PASSWORD_LENGTH_ERROR = `Your password must contain at least ${MIN_LENGTH} characters`;
export const PASSWORD_TYPES_ERROR = `Your password must contain ${TYPES_RULE}`;

/** Which length or character-type rule the password breaks; null when it
 * meets them. Auth0 may still reject it at submit. */
export const passwordError = (password: string): string | null => {
  if (password.length > MAX_LENGTH) {
    return `Your password must be at most ${MAX_LENGTH} characters`;
  }
  const tooShort = password.length < MIN_LENGTH;
  const tooFewTypes =
    CHARACTER_TYPES.filter((type) => type.test(password)).length <
    MIN_CHARACTER_TYPES;
  if (tooShort && tooFewTypes) return PASSWORD_HINT;
  if (tooShort) return PASSWORD_LENGTH_ERROR;
  if (tooFewTypes) return PASSWORD_TYPES_ERROR;
  return null;
};
